import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { setPrimaryTracker } from 'usage-tracker-container';
import { Map as ImmutableMap } from 'immutable';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { configureStorePublicApp } from './utils/configureStorePublicApp';
import UsageTrackerPublic from './utils/UsageTrackerPublic';
// @ts-expect-error Untyped module
import PublicAchievementContainer from './containers/Achievements/PublicAchievementContainer';
import { dataFetchingClient } from './utils/DataFetchingClient';
import { DataFetchingClientProvider } from 'academy-common-lib/utils/DataFetchingClient';
import { BrowserRouter, Route } from 'react-router-dom';
import { ThemeProvider } from 'academy-common-lib/utils/Styling';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicAppRouter = () => {
  useEffect(() => {
    setPrimaryTracker(UsageTrackerPublic.tracker);
  }, []);
  const store = configureStorePublicApp({
    achievement: ImmutableMap()
  });
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ThemeProvider, {
      children: /*#__PURE__*/_jsxs(DataFetchingClientProvider, {
        client: dataFetchingClient,
        children: [/*#__PURE__*/_jsx(UIFloatingAlertList, {}), /*#__PURE__*/_jsx(Provider, {
          store: store,
          children: /*#__PURE__*/_jsx(BrowserRouter, {
            basename: "/academy",
            children: /*#__PURE__*/_jsx(Route, {
              children: ({
                history
              }) => /*#__PURE__*/_jsx(RhumbProvider, {
                config: rhumbConfig // defining rhumbConfig as any is common across HubSpot due to lack of types
                ,
                history: historyAdapter(history),
                children: /*#__PURE__*/_jsx(Route, {
                  component: PublicAchievementContainer,
                  path: `/achievements/:publicId/:language/:template/:slug+`
                })
              })
            })
          })
        })]
      })
    })
  });
};
export default PublicAppRouter;